import React from 'react'
import about from '../assets/images/presentation-3-87.svg'
import { Link } from 'react-router-dom'

export default function AboutOne() {
  return (
    <>
    <div className="row g-4 align-items-center">
        <div className="col-lg-6 col-md-6 order-1 order-md-2">
            <div className="position-relative">
                <img src={about} className="img-fluid" alt=""/>

                <div className="modern-app-round round-small"></div>
            </div>
        </div>

        <div className="col-lg-6 col-md-6 order-md-1 order-2">
            <div className="section-title me-lg-5">
                <h4 className="title mb-3">We create world-class digital <br/> products materials that <br/> communicate clearly.</h4>
                <p className="text-muted para-desc mb-0">We've cultivated a dynamic space where creativity seamlessly intertwines with strategy and innovation.</p>
            
                <ul className="list-unstyled text-muted mb-0 mt-3">
                    <li className="mb-1"><span className="text-primary h5 me-2"><i className="mdi mdi-check-circle-outline align-middle"></i></span>Digital Marketing Solutions for Tomorrow</li>
                    <li className="mb-1"><span className="text-primary h5 me-2"><i className="mdi mdi-check-circle-outline align-middle"></i></span>Our Talented & Experienced Marketing Agency</li>
                    <li className="mb-1"><span className="text-primary h5 me-2"><i className="mdi mdi-check-circle-outline align-middle"></i></span>Create your own skin to match your brand</li>
                </ul>

                <div className="mt-4">
                    <Link to="/aboutus" className="btn btn-primary">About Us <i className="mdi mdi-arrow-right align-middle"></i></Link>
                </div>
            </div>
        </div>
    </div>
    </>
  )
}
